import { useEffect, useRef, useCallback } from 'react';

export function useAdminWebSocket(token, relayUrl, onMessage, onDisconnect) {
  const wsRef           = useRef(null);
  const reconnectTimer  = useRef(null);
  const mountedRef      = useRef(true);
  const onMessageRef    = useRef(onMessage);
  const onDisconnectRef = useRef(onDisconnect);
  onMessageRef.current  = onMessage;
  onDisconnectRef.current = onDisconnect;

  const connect = useCallback(() => {
    if (!token || !mountedRef.current) return;

    const wsUrl = (relayUrl || 'http://localhost:3001').replace(/^http/, 'ws');
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
      ws.send(JSON.stringify({ event: 'admin_register', data: { admin_token: token } }));
    };

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        onMessageRef.current?.(msg);
      } catch {}
    };

    ws.onclose = () => {
      onDisconnectRef.current?.();
      if (!mountedRef.current) return;
      const delay = Math.min(30000, 2000);
      reconnectTimer.current = setTimeout(connect, delay);
    };

    ws.onerror = () => ws.close();
  }, [token, relayUrl]);

  useEffect(() => {
    mountedRef.current = true;
    connect();
    return () => {
      mountedRef.current = false;
      clearTimeout(reconnectTimer.current);
      if (wsRef.current) {
        wsRef.current.onclose = null; // Prevent reconnect on intentional close
        wsRef.current.close();
      }
    };
  }, [connect]);

  return wsRef;
}
